<template>
  <div>
    <vue-base64-file-upload
      v-if="!question.file_url"
      class="upload_wrapper"
      accept="image/png, image/jpeg"
      image-class="upload_imagepreview"
      input-class="upload_imageinput"
      :disable-preview="true"
      :max-size="customImageMaxSize"
      @size-exceeded="onSizeExceeded"
      @file="onFile"
      @load="onLoad"
    />
    <div v-if="question.file_url">
      <div class="illus_question" @click="deleteImageQuestion">
        <img style="height:120px;" :src="question.file_url" />
        <div class="overlay">
          <b-icon pack="fas" icon="trash" size="is-medium"></b-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueBase64FileUpload from 'vue-base64-file-upload'
export default {
  name: 'ButtonImageQuestion',
  props: ['question'],
  components: {
    VueBase64FileUpload
  },
  data () {
    return {
      customImageMaxSize: 4,
      hover: false
    }
  },
  methods: {
    onSizeExceeded (size) {
      alert(
        `Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
      )
    },
    onFile (file) {},
    onLoad (dataUri) {
      this.question.file_url = dataUri
    },
    deleteImageQuestion () {
      this.question.file_url = ''
    }
  }
}
</script>
<style scoped>
.illus_question {
    position: relative;
    opacity: 1;
    /*height: 144px;*/
  }
  .illus_question:hover .overlay {
    opacity: 1;
    cursor: pointer;
  }
  .illus_question:hover img {
    cursor: pointer;
    opacity: 0.3;
  }
  .overlay {
    opacity: 0;
    position: absolute;
    top: 39%;
    left: 43%;
  }

  .delete_illus_question,
  .delete_illus_answer {
    position: absolute;
    top: -11px;
    right: -9px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/question/components/ButtonImageQuestion.vue